import type { FaireProductEntity } from "../../entity_types/product";

export const pom_pom_1: FaireProductEntity = {
  token: "pom-pom-1",
  type: "product",
  name: "Popcorn, Miso Caramel",
  brandName: "Pom Pom Popcorn by Bessou",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c890d332a21362576262df69755ec3d7872892347ea6abdc79bb718cb28e35dd.webp",
  priceDollars: 10,
  msrpDollars: 16,
  freeShipping: false,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
